import RiveAnimation from "@/components/animation/RiveAnimation";
import PurpleRadialGradientBackground from "@/components/background/purple-radial-gradient";
import { PageContainer } from "@/components/container/page-container";
import { LogoIcon } from "@/components/icons/logo-icon";
import { useCreatePlan } from "@/hooks/requests/plan/use-create-plan";
import { useToast } from "@/hooks/ui/use-toast";
import { useStepRouteInfo } from "@/hooks/use-step-route-info";
import { cn } from "@/utils/cn";
import { textVariants } from "@/utils/text-variants";
import { useEffect, useState } from "react";
import { AnimatedProgressBar } from "../../components/animated-progress-bar";

interface ProgressStep {
  title: string;
  targetProgress: number;
}

const STEPS: ProgressStep[] = [
  {
    title: "Searching for food...",
    targetProgress: 25,
  },
  {
    title: "Adding some indulgence...",
    targetProgress: 50,
  },
  {
    title: "Calculating your calories...",
    targetProgress: 100,
  },
] as const;

const ANIMATION_DURATION = 1000;

export default function OnboardingBuildingScreen() {
  const [stepIndex, setStepIndex] = useState(0);
  const { navigateToNextStep } = useStepRouteInfo();
  const { showError } = useToast();
  const { updatePlanAsync } = useCreatePlan();

  useEffect(() => {
    setStepIndex(1);
    updatePlanAsync()
      .then(() => {
        setStepIndex(2);
        setTimeout(() => {
          navigateToNextStep();
        }, ANIMATION_DURATION);
      })
      .catch((error) => {
        showError(error.message);
      });
  }, []);

  return (
    <PageContainer showToolbar={false}>
      <PurpleRadialGradientBackground
        classNames={{
          container: cn(
            "w-full flex flex-col justify-between items-center pt-8 pb-12",
          ),
          image: cn("bottom-0"),
        }}
      >
        <LogoIcon className="w-[177px] h-[45px]" logoColor="black" />
        <div className="flex items-center justify-center w-full px-8">
          <RiveAnimation
            src="/assets/animations/building_searching_food.riv"
            className="w-[320px] h-[300px]"
          />
        </div>

        <div className="flex flex-col items-center gap-3 px-8">
          <h1 className={cn(textVariants.headline, "text-center uppercase")}>
            {STEPS[stepIndex].title}
          </h1>
          <p className={cn(textVariants.bodySingleLine, "text-center")}>
            This will take a short while
          </p>
        </div>

        <AnimatedProgressBar
          targetProgress={STEPS[stepIndex].targetProgress}
          animationDuration={ANIMATION_DURATION}
        />
      </PurpleRadialGradientBackground>
    </PageContainer>
  );
}
